<abp-modal
  [visible]="isVisible()"
  (visibleChange)="onModalVisibleChange($event)"
  [suppressUnsavedChangesWarning]="true"
  [options]="{ size: 'lg' }">
  <ng-template #abpHeader>
    <div class="modal-header-title">
      <h3>{{ modalTitle() | abpLocalization }}</h3>
      <h4>{{ entityLocaleKey() | abpLocalization }}</h4>
    </div>
  </ng-template>

  <ng-template #abpBody>
    <form class="zn-form" [ngClass]="cssClasses()" [formGroup]="form()">
      <div class="row">
        @for (field of visibleFields(); track field) {
        <app-generic-field
          [ngClass]="visibleFields().length === 1 ? 'col-12' : 'col-6'"
          [field]="field"
          [form]="form()"
          [allFields]="fields()"
          [isEditMode]="mode() === 'edit'"
          [originalValues]="originalValues()"
        />
        }
      </div>
    </form>
  </ng-template>
  
  <ng-template #abpFooter>
    <zn-button
      type="secondary"
      (clicked)="onFormCancel()"
      [label]="localizationServices.LanguageService + '::Close' | abpLocalization"
    ></zn-button>
    <zn-button
      (clicked)="onSubmit()"
      [label]="localizationServices.LanguageService + '::Save' | abpLocalization"
      [disabled]="!form().valid"
    ></zn-button>
  </ng-template>
</abp-modal>
